module.exports = __webpack_public_path__ + "img/typescript.9ba1f768.svg";